export const $ = <T extends HTMLElement = HTMLElement>(sel: string, root: ParentNode = document) =>
  root.querySelector<T>(sel);
export const $$ = <T extends HTMLElement = HTMLElement>(sel: string, root: ParentNode = document) =>
  [...root.querySelectorAll<T>(sel)];
export const byId = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T | null;

/** Escape text for safe interpolation into innerHTML templates. */
export const esc = (value: unknown) =>
  String(value ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]!);

let toastTimer: number | undefined;
export function toast(message: string) {
  const el = byId("toast");
  if (!el) return;
  el.textContent = message;
  el.classList.add("show");
  window.clearTimeout(toastTimer);
  toastTimer = window.setTimeout(() => el.classList.remove("show"), 2400);
}

export function on<K extends keyof HTMLElementEventMap>(
  target: HTMLElement | null,
  type: K,
  handler: (ev: HTMLElementEventMap[K]) => void,
) {
  target?.addEventListener(type, handler as EventListener);
}
